import { ProductLaunchModalContent } from 'features/StartupModals/CMSProductLaunchModal/ProductLaunchModalContent'
import { useCorporateCardStartupModal } from 'features/StartupModals/CorporateCardStartup/useCorporateCardStartupModal'

export const CorporateCardStartup = () => {
  const { handleCreateCard } = useCorporateCardStartupModal()
  return (
    <ProductLaunchModalContent
      slug="dashboard-plm-corporate-cards"
      statusName="showCorporateCardsAdminWelcome"
      onClick={handleCreateCard}
    />
  )
}
